import styled from 'styled-components'

export const SelectOption = styled.div<{ disabled?: boolean }>`
  cursor: pointer;
  width: 100%;
  padding: 0.5rem 0;
  display: flex;
  background-color: ${(props) => props.theme.appBackground};
  align-items: center;
  padding-left: 1em;
  z-index: 9999999999999 !important;
  transition: 0.13s ease-in;

  &:hover {
    background-color: ${(props) => props.theme.inputActiveBackground};
    color: white;
    border: none;
  }

  ${(props) =>
    props.disabled &&
    ` opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
      background-color: ${props.theme.appBackground};
      color: ${props.theme.textColor};
      cursor: not-allowed;
      `}
`

export const OptionsContainer = styled.div`
  height: fit-content;
  bottom: 115%;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 9999999999999 !important;
  background-color: white;
  max-height: 200px;
  overflow-y: auto;
  ${(props) => props.theme.container};
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
`

export const MultiSingle = styled.div`
  height: 100%;
  border-radius: 5px;
  background-color: ${(props) => props.theme.placeholder};
  padding: 0 7px;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;

  svg {
    min-width: 15px !important;
    max-height: 15px !important;
    transition: 0.3s ease;
    &:hover {
      transform: scale(1.3);
    }
  }
`

export const SelectInput = styled.input`
  color: ${(props) => props.theme.textColor};

  &::placeholder {
    font-size: 16px;
    color: #8a8a8a;
    line-height: 20px;
    font-weight: 400;
    opacity: 1; /* Firefox applies a lower opacity by default, so set this to 1 for consistency */
  }
`

export const Placeholder = styled.p`
  font-size: 16px;
  color: #8a8a8a;
  line-height: 20px;
  font-weight: 400;
  opacity: 1; /* Firefox applies a lower opacity by default, so set this to 1 for consistency */
`

export const Select = styled.div<{
  invalid?: boolean
  active?: boolean
  value?: boolean
  blured?: boolean
}>`
  width: 100%;
  margin: 0.2rem 0;
  height: 40px;
  color: #454545;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid
    ${(props) => {
      return props.active
        ? '#ff9900'
        : !props.invalid && props.value
        ? props.theme.colorDividerLight
        : props.invalid && props.blured
        ? '#E74C3C'
        : props.theme.colorDividerDefault
    }};
  transition: 0.5s ease;
  padding: 0 1rem;
  font-size: 0.87rem;
  background-color: ${(props) => props.theme.colorSurface1};

  &:hover {
    border: 1px solid ${(props) => props.theme.colorDividerLight};
  }
`
